import { post } from "../../service/api";

const ResetPassword = async (token, password) => {
  try {
    const response = await post(`/merchant/resetPassword`, {
      token,
      password,
    });
    return response;
  } catch (error) {
    console.error("Error ResetPassword:", error);
    throw error;
  }
};

export default ResetPassword;
